// Ensure viewport-fit=cover for safe-area-inset and set near-white meta
(function(){
  var v=document.querySelector('meta[name="viewport"]');
  if(v&&v.content.indexOf('viewport-fit')===-1)v.content+=',viewport-fit=cover';
  var t='theme-',c='color',m=document.querySelector('meta[name="'+t+c+'"]');
  if(m)m.setAttribute('content','#fefefe');
})();
